import { Injectable } from '@angular/core'
import { Store } from '../../../shared/models/store'
import { ChantierDto } from '../../../shared/data-access/dto/chantier.dto'
import { AccueilDetail } from '../../../shared/models/accueil'

export interface HomeStateModel {
  selectedChantier: ChantierDto
  selectedAccueil: AccueilDetail
  isChantierEmpty: boolean
}

@Injectable({ providedIn: 'root' })
export class HomeState {
  readonly store = new Store<HomeStateModel>({
    selectedChantier: null,
    selectedAccueil: null,
    isChantierEmpty: false,
  })

  static getSelectedChantier = (state: HomeStateModel): ChantierDto => state.selectedChantier
  static getSelectedAccueil = (state: HomeStateModel): AccueilDetail => state.selectedAccueil
  static getIsChantierEmpty = (state: HomeStateModel): boolean => state.isChantierEmpty
}
